









































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
class PageOffineWarningRequest extends PageRequest {
  FilterText: string;
  cId:Number;
  AddTime:Date=new Date();
  Tempscope:string;
  Humiscope:string;
}
class PageCompanyRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
}
@Component({
  components: {},
})
export default class Floors extends AbpBase {
  pagerequest: PageOffineWarningRequest = new PageOffineWarningRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId:Number;
  searchInt:number = 0;
  selwarehouselist = [];
  selfloorlist = [];
  get list() {
    
    return this.$store.state.thdata.list;
  }
  get loading() {
    return this.$store.state.thdata.loading;
  }
  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getwarehouse();
      this.getfloor();
      this.searchInt = 1;
       this.getpage();
  }
  //库区
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    // this.getwarehouse();
    //   this.getfloor();
     if(value != 0){
      this.getselwarehouse();
      this.selfloorlist = [];
    }
    else if(value == 0)
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
      this.searchInt = 1;
       this.getpage();
  }
  //库房
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
      //this.getfloor();
      if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
      this.searchInt = 1;
       this.getpage();
  }
  //楼层
  selfloor(value:Number){
    this.searchInt = 1;
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("thdata/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("thdata/setPageSize", pagesize);
    this.getpage();
  }
  getsearch(){
    this.searchInt = 1;
    this.getpage();
  }
  async getpage() {
    if(this.searchInt == 1){
      this.$store.state.thequipment.currentPage=1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    }
    else{
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    
    //filters
    await this.$store.dispatch({
      type: "thdata/GetOffWarningPaged",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.thdata.pageSize;
  }
  get totalCount() {
    return this.$store.state.thdata.totalCount;
  }
  get currentPage() {
    return this.$store.state.thdata.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }

  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    
    {
      title: "库房",
      key: "wName",
    },
    {
      title: "楼层",
      key: "fName",
    },
    {
      title: "SN号",
      key: "mac",
    },
     {
      title: "烟叶",
      key: "scId",
      render: (h, params) => {
        let scId = params.row.scId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
            scId=entry.title;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "位置",
      key: "locationName",
    },
    {
      title: "最后采集时间",
      key: "endtime",
      render: (h, params) => {
        let endTime ='';
        endTime=this.GetDay(params.row.endTime)+' '+this.GetMinutes(params.row.endTime);
        return h("span", endTime);
      },
    },
  ];
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
   
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
     async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
  }
  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  created() {
     this.$store.state.thdata.pageSize=10;
    this.$store.state.thdata.currentPage=1;
    this.$store.state.thdata.totalCount=0;
    this.getuserName();
    if (this.userName !== "admin") {
      this.getwarehouse();
      this.getfloor();
      this.getfactory();
      this.getsmokecrib();
      
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getpage();
  }
}
